module.exports = __webpack_public_path__ + "e91b1273f3331da3c63d13c07dafe1b3.png";